import Pusher from "pusher-js";

let pusherInstance = null;

export function getPusher() {
  if (!pusherInstance) {
    pusherInstance = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
      cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
      encrypted: true,
    });
  }

  return pusherInstance;
}